// extracted by mini-css-extract-plugin
module.exports = {"bottom":"tooltip-module__bottom___2SWja","left":"tooltip-module__left___1nh0Z","right":"tooltip-module__right___3vcd8","top":"tooltip-module__top___342bT"};